/**
 * Earth's radius in miles
 */
const EARTH_RADIUS_MILES = 3958.8;
/**
 * Convert degrees to radians
 */
function toRadians(degrees) {
    return degrees * (Math.PI / 180);
}
/**
 * Calculate the distance between two coordinates using the Haversine formula
 * @param lat1 Latitude of first point
 * @param lng1 Longitude of first point
 * @param lat2 Latitude of second point
 * @param lng2 Longitude of second point
 * @returns Distance in miles
 */
export function calculateDistanceMiles(lat1, lng1, lat2, lng2) {
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
            Math.cos(toRadians(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_MILES * c;
}
/**
 * Add distance to items and sort by distance ascending
 * @param items Array of items with lat/lng properties
 * @param userLat User's latitude
 * @param userLng User's longitude
 * @returns Items with distanceMiles added, sorted by distance ascending
 */
export function sortByDistance(items, userLat, userLng) {
    return items
        .map((item) => ({
        ...item,
        distanceMiles: calculateDistanceMiles(userLat, userLng, item.lat, item.lng),
    }))
        .sort((a, b) => a.distanceMiles - b.distanceMiles);
}
